import { Add, Remove } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { useState } from "react";

interface CounterProps {
  initialValue?: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: (value: number) => void;
}

const btnStyles = { minWidth: 40, width: 40, height: 40, padding: 0 };

const Counter: React.FC<CounterProps> = ({
  initialValue = 0,
  min = 0,
  max = Number.POSITIVE_INFINITY,
  step = 1,
  onChange,
}) => {
  const [count, setCount] = useState<number>(initialValue);

  const updateCount = (newValue: number) => {
    if (newValue >= min && newValue <= max) {
      setCount(newValue);
      onChange?.(newValue);
    }
  };

  const handleIncrement = () => updateCount(count + step);
  const handleDecrement = () => updateCount(count - step);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    updateCount(Number.isNaN(value) ? initialValue : value);
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button
        variant="contained"
        color="inherit"
        onClick={handleDecrement}
        disabled={count <= min}
        sx={btnStyles}
      >
        <Remove />
      </Button>
      <TextField
        type="number"
        value={count}
        onChange={handleChange}
        sx={{
          width: 64,
          height: 40,
          "& input": { textAlign: "center", height: 40, padding: 0 },
          "& input[type=number]": { MozAppearance: "textfield" },
          "& input[type=number]::-webkit-outer-spin-button": {
            display: "none",
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            display: "none",
          },
        }}
        size="small"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleIncrement}
        disabled={count >= max}
        sx={btnStyles}
      >
        <Add />
      </Button>
    </Stack>
  );
};

export default Counter;
